<div class="events-container">
  <ag-grid-angular
    class="ag-theme-balham-dark events-container__ag-grid"
    [enableRangeSelection]="true"
    [columnDefs]="headers"
    [defaultColDef]="defaultColDef"
    [autoGroupColumnDef]="{ sortable: true }"
    rowSelection="multiple"
    [groupSelectsChildren]="true"
    [suppressRowClickSelection]="true"
    [sideBar]="sideBarDef"
    (gridReady)="onGridReady($event)"
    (sortChanged)="gridStateChanged($event)"
    (columnResized)="gridStateChanged($event)"
    (columnVisible)="gridStateChanged($event)"
    (columnMoved)="gridStateChanged($event)"
    (columnPivotChanged)="gridStateChanged($event)"
    (columnRowGroupChanged)="gridStateChanged($event)"
    (columnValueChanged)="gridStateChanged($event)"
    (columnMoved)="gridStateChanged($event)"
    (columnPinned)="gridStateChanged($event)"
    [rowData]="rowData"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
  >
  </ag-grid-angular>

  <div class="events-container__footer">
    <div class="events-container__footer__info">
      <ng-container *ngIf="state.info">{{ state.info }}</ng-container>
      <ng-container
        *ngIf="state.runningState === RunningState.Running && !state.info"
      >
        Report running. Some reports might take a while.
      </ng-container>
    </div>

    <form [formGroup]="form">
      <app-selector
        [isSearch]="true"
        [passedItems]="entities"
        placeholder="Select an entity or type to search"
        formControlName="entity"
      ></app-selector>
      <app-selector
        [passedItems]="horizons"
        placeholder="Select a horizon"
        formControlName="horizon"
      ></app-selector>
    </form>
    <div class="events-container__footer__buttons">
      <button
        type="button"
        class="ui-button ui-button__header ui-button--danger"
        [disabled]="state.runningState === RunningState.Idle"
        (click)="cancelReport()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="ui-button ui-button__header ui-button--primary"
        [disabled]="state.runningState === RunningState.Running || form.invalid"
        (click)="runReport()"
      >
        Run
      </button>
    </div>
  </div>
</div>
